import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import {toBuildTypeId} from '../../../../types'
import type {ThinNestedEntryPointParamsObject} from '../../../../types/entryPoints'
import {makeResource} from '../../../../utils/makeResource'
import {queryToObject} from '../../../../utils/queryParams'
import {TagsFiltersEntryPoint} from '../../../common/TagsList/TagsFilters.entryPoint'
import {EditPipelinePageEntryPoint} from '../EditPipelinePage/EditPipelinePage.entryPoint'

import {PipelineContentEntryPoint} from './PipelineContent/PipelineContent.entryPoint'
import type {NestedEntryPoints, PipelinePageComponent} from './PipelinePage'
import {query} from './PipelinePage.queries'

export const PipelinePageEntryPoint: EntryPoint<PipelinePageComponent, LoaderFunctionArgs> = {
  root: makeResource(
    'PipelinePage',
    () => import(/* webpackChunkName: "PipelinePage" */ './PipelinePage'),
  ),
  getPreloadProps: args => {
    const {params, request} = args
    const url = new URL(request.url)
    const {edit} = queryToObject(url.search)

    const entryPoints: ThinNestedEntryPointParamsObject<NestedEntryPoints> = {
      pipelineContent: {
        entryPoint: PipelineContentEntryPoint,
        entryPointParams: {},
      },
      tagsFilters: {
        entryPoint: TagsFiltersEntryPoint,
        entryPointParams: toBuildTypeId(params.pipelineId!), // Use pipelineId as buildTypeId for now
      },
    }

    if (edit === 'true') {
      entryPoints.editPipelineContent = {
        entryPoint: EditPipelinePageEntryPoint,
        entryPointParams: args,
      }
    }
    return {
      queries: {
        pipelineHead: {
          parameters: getRequest(query),
          variables: {locator: `id:${params.pipelineId}`},
          options: {networkCacheConfig: {metadata: {essential: true}}},
        },
      },
      entryPoints,
    }
  },
}
